if (!customElements.get('notification-popup')) {
  customElements.define(
    'notification-popup',
    class NotificationPopup extends HTMLElement {
      constructor() {
        super();

        if (getCookie('notification-popup') != '') return;

        this.time = this.dataset.notificationTime;
        this.popup = this.querySelector('.notification-popup');
        this.product = this.querySelector('.notification-popup__product');
        this.contentTemplate = this.querySelector('template').content.firstElementChild.innerHTML;
        this.imageTemplate = this.querySelector('template').content.lastElementChild.innerHTML;
        this.index = 0;
        this.objects = window.notification_objects || {};
        if (Object.keys(this.objects).length != 0) this.items = JSON.parse(`[${this.objects}]`);
        if (this.items.length == 0) return;
        setInterval(() => this.init(), this.time);
      }

      init() {
        if(this.popup.classList.contains('active')) {
          this.popup.classList.remove('active');
        } else {
          // let itemIndex = Math.floor(Math.random() * this.items.length);
          let item = this.items[this.index],
            productTitle = item.product_title,
            productImage = item.product_image,
            productImageAlt = item.product_image_alt,
            productImageHeight = item.product_image_height,
            productUrl = item.product_url,
            productId = item.product_id,
            firstText = item.first_text,
            secondText = item.second_text,
            productContent = this.contentTemplate,
            productMedia = this.imageTemplate;

          if(productImage != undefined) {
            productMedia = productMedia.replaceAll('[product_image]', productImage);
            productMedia = productMedia.replaceAll('[product_image_alt]', productImageAlt);
            productMedia = productMedia.replaceAll('[product_image_height]', productImageHeight);
          } else {
            productMedia = window.placeholder_svg[`product_${item.placeholder_image_index}`];
          }

          productContent = productContent.replaceAll('[product_media]', productMedia);
          productContent = productContent.replaceAll('[product_title]', productTitle);
          productContent = productContent.replaceAll('[product_url]', productUrl);
          productContent = productContent.replaceAll('[product_id]', productId);
          productContent = productContent.replaceAll('[first_text]', firstText);
          productContent = productContent.replaceAll('[second_text]', secondText);

          this.index = this.index + 1;
          if(this.index == this.items.length) this.index = 0;
          const html = new DOMParser().parseFromString(productContent, 'text/html');
          this.product.innerHTML = html.body.innerHTML;
          this.popup.classList.add('active');
        }
      }

      destroy(expiresDate = 1) {
        setCookie('notification-popup', 'closed', expiresDate);
        this.popup.classList.remove('active');
        this.remove();
      }
    }
  );
}